import { LINK_TITLE } from '../elements/link'

export const PERMISSION_AUDIT = `
...on permissionAudit_Entry {
  id
  typeHandle

  heading: headingAdvanced {
    html
  }
  description
  backgroundColor

  buttonLabel
  ${ LINK_TITLE }
  buttonFormPopup

  metricBarTable {
    col1
    col2
    col3
  }
}
`